import ZObject from "zobject/ZObject.js";

export default superclass => class extends superclass {
    newZObject() {
        return new ZObject(this);
    }
}

